/**
 * Languages the site is published in. Polish is the fallback.
 *
 * Client decision 2026-08-05 (docs/05-CLIENT-BRIEF-ANALYSIS.md): launch is
 * PL/UA/RU; English comes later. `uk` is the ISO 639-1 code for Ukrainian —
 * the UI shows it as "UA" because that's what the audience expects.
 */
export const LOCALES = ['pl', 'uk', 'ru'];
export const DEFAULT_LOCALE = 'pl';
export const LOCALE_LABELS = {
    pl: 'Polski',
    uk: 'Українська',
    ru: 'Русский',
};
/** Short labels for the header switcher: PL | UA | RU. */
export const LOCALE_SHORT = {
    pl: 'PL',
    uk: 'UA',
    ru: 'RU',
};
/** Diana is ADMIN. Everyone else is STUDENT. There is no third role. */
export const ROLES = ['ADMIN', 'STUDENT'];
/**
 * Diana's own timezone. Availability rules are stored as wall-clock time in
 * this zone so that "Mondays 16:00" survives daylight saving changes.
 * See docs/04-ARCHITECTURE.md §8.
 */
export const OWNER_TIMEZONE = 'Europe/Warsaw';
/** Social channels. `tiktok` cannot auto-publish — see docs/02-SOCIAL-MARKETING.md. */
export const CHANNELS = ['instagram', 'facebook', 'tiktok'];
